"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var deprecate = function deprecate() {
  return function (Wrapped) {
    return Wrapped;
  };
};

if (process.env.NODE_ENV) {
  deprecate = function deprecate(_ref) {
    var message = _ref.message,
        name = _ref.name;
    return function (Wrapped) {
      var componentName = name || Wrapped.displayName || 'this';
      var warningMessage = "Warning: Using deprecated component ".concat(componentName, ". ").concat(message || 'This will be removed in the next major version.');
      console.warn(warningMessage);

      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(warningMessage);
      } catch (x) {}

      return Wrapped;
    };
  };
}

var _default = deprecate;
exports.default = _default;
//# sourceMappingURL=deprecate.js.map